// Redirect to cart after add to cart
document.addEventListener('submit', function(e) {
  const form = e.target;
  if (form.action && form.action.includes('/cart/add')) {
    e.preventDefault();
    const data = new FormData(form);
    fetch('/cart/add', {
      method: 'POST',
      body: data
    }).then(function() {
      window.location.href = '/cart';
    });
  }
});
function swapImg(thumb, src) {
  document.getElementById('mainImg').src = src;
  document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}
function selectVariant(btn, price) {
  document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
  document.getElementById('displayPrice').textContent = price;
  const variantId = btn.getAttribute('data-variant-id');
  if (variantId) {
    document.getElementById('variant-id').value = variantId;
  }
}
function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}
const observer = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.style.opacity = '1';
      e.target.style.transform = 'translateY(0)';
    }
  });
}, { threshold: 0.08 });
document.querySelectorAll('.why-card, .transform-card, .highlight-item, .reframe-pill').forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(18px)';
  el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
  observer.observe(el);
});
// Sticky nav fix for iOS Safari
const nav = document.querySelector('nav');
if (nav) {
  const navHeight = nav.offsetHeight;
  const navTop = nav.getBoundingClientRect().top + window.pageYOffset;
  
  window.addEventListener('scroll', function() {
    if (window.pageYOffset > navTop) {
      nav.style.position = 'fixed';
      nav.style.top = '0';
      nav.style.left = '0';
      nav.style.right = '0';
      nav.style.zIndex = '100';
      document.body.style.paddingTop = navHeight + 'px';
    } else {
      nav.style.position = 'relative';
      nav.style.top = '';
      document.body.style.paddingTop = '0';
    }
  }, { passive: true });
}
// Force redirect when pre-order button is clicked
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.add-to-cart');
  if (btn) {
    e.preventDefault();
    e.stopPropagation();
    const form = btn.closest('form');
    if (form) {
      const data = new FormData(form);
      fetch('/cart/add', {
        method: 'POST',
        body: data
      }).then(function() {
        window.location.href = '/cart';
      });
    } else {
      window.location.href = '/cart';
    }
  }
}, true);

